import { render, staticRenderFns } from "./CrmDealOrder.vue?vue&type=template&id=470db1f0"
import script from "./CrmDealOrder.vue?vue&type=script&lang=js"
export * from "./CrmDealOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports